import { request, success, failure, PROVIDENT_FUND_REQUEST } from "./utilities";
import { getFundList, addNewFund, removeFund } from "../api";

export function getAllFundList() {
  return (dispatch) => {
    dispatch(request(PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_REQUEST));
    let response = [
      {
        id: 0,
        employeeName: "Zahid",
        providentFundType: "Percentage of Basic Salary",
        employeeShare: "3.5%",
        companyShare: "4.0%",
        employeePercent: "3.5%",
        companyPercent: "4.0%",
        startedDate: "01/15/2021",
        status: "APPROVED",
      },
      {
        id: 1,
        employeeName: "Faizan",
        providentFundType: "Fixed Contribution",
        employeeShare: "5.0%",
        companyShare: "5.0%",
        employeePercent: "5.0%",
        companyPercent: "5.0%",
        startedDate: "03/20/2020",
        status: "APPROVED",
      },
      {
        id: 2,
        employeeName: "Usama",
        providentFundType: "Percentage of Basic Salary",
        employeeShare: "2.5%",
        companyShare: "3.0%",
        employeePercent: "2.5%",
        companyPercent: "3.0%",
        startedDate: "08/10/2022",
        status: "APPROVED",
      },
      {
        id: 3,
        employeeName: "Ayaz",
        providentFundType: "Fixed Contribution",
        employeeShare: "4.0%",
        companyShare: "4.0%",
        employeePercent: "4.0%",
        companyPercent: "4.0%",
        startedDate: "05/01/2023",
        status: "PENDING",
      },
      {
        id: 4,
        employeeName: "Farhan",
        providentFundType: "Percentage of Basic Salary",
        employeeShare: "2.0%",
        companyShare: "2.5%",
        employeePercent: "2.0%",
        companyPercent: "2.5%",
        startedDate: "12/18/2019",
        status: "APPROVED",
      },
      {
        id: 5,
        employeeName: "Shehreyar",
        providentFundType: "Fixed Contribution",
        employeeShare: "3.0%",
        companyShare: "3.0%",
        employeePercent: "3.0%",
        companyPercent: "3.0%",
        startedDate: "11/11/2021",
        status: "REJECTED",
      },
      {
        id: 6,
        employeeName: "Noman",
        providentFundType: "Percentage of Basic Salary",
        employeeShare: "4.5%",
        companyShare: "5.0%",
        employeePercent: "4.5%",
        companyPercent: "5.0%",
        startedDate: "07/25/2020",
        status: "APPROVED",
      },
      {
        id: 7,
        employeeName: "Umer",
        providentFundType: "Fixed Contribution",
        employeeShare: "5.0%",
        companyShare: "5.0%",
        employeePercent: "5.0%",
        companyPercent: "5.0%",
        startedDate: "04/14/2023",
        status: "PENDING",
      },
      {
        id: 8,
        employeeName: "Aamir",
        providentFundType: "Percentage of Basic Salary",
        employeeShare: "2.0%",
        companyShare: "3.0%",
        employeePercent: "2.0%",
        companyPercent: "3.0%",
        startedDate: "06/30/2022",
        status: "APPROVED",
      },
      {
        id: 9,
        employeeName: "Waqas",
        providentFundType: "Fixed Contribution",
        employeeShare: "4.0%",
        companyShare: "4.5%",
        employeePercent: "4.0%",
        companyPercent: "4.5%",
        startedDate: "01/07/2020",
        status: "APPROVED",
      },
    ];

    dispatch(success(PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_SUCCESS, response));
    // getFundList().then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_SUCCESS, response.data.data));
    //         }
    //         else {
    //             dispatch(failure(PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_FAILURE, response.data.message));
    //         }
    //     },
    //     error => {
    //         dispatch(failure(PROVIDENT_FUND_REQUEST.GET_FUNDS_LIST_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
    //     }
    // )
  };
}

export function addFund(fundData, close) {
  return (dispatch) => {
    dispatch(request(PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_REQUEST));
    dispatch(success(PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_SUCCESS, fundData));
    if (close) {
      close();
    }
    // addNewFund(fundData).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_SUCCESS, response.data.data))
    // if (close) {
    //     close()
    // }
    //         }
    //         else {
    //             dispatch(failure(PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(PROVIDENT_FUND_REQUEST.ADD_FUNDS_LIST_FAILURE, (error && error.response && error.response.data && error.response.data.title) ? error.response.data.title : error.message))
    //     }
    // )
  };
}

export function editFund(fundData) {
  return (dispatch) => {
    dispatch(request(PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_REQUEST));
    dispatch(success(PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_SUCCESS, fundData));
    // addNewFund(fundData).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_SUCCESS, response.data.data))
    //         }
    //         else {
    //             dispatch(failure(PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(PROVIDENT_FUND_REQUEST.EDIT_FUNDS_LIST_FAILURE, (error && error.response && error.response.data && error.response.data.title) ? error.response.data.title : error.message))
    //     }
    // )
  };
}

export function deleteFund(fundId) {
  return (dispatch) => {
    dispatch(request(PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_REQUEST));
    dispatch(success(PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_SUCCESS, fundId));
    // removeFund(fundId).then(
    //     response => {
    //         if (response.data.status === 1) {
    //             dispatch(success(PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_SUCCESS, fundId))
    //         }
    //         else {
    //             dispatch(failure(PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_FAILURE, response.data.message))
    //         }
    //     },
    //     error => {
    //         dispatch(failure(PROVIDENT_FUND_REQUEST.DELETE_FUNDS_LIST_SUCCESS, (error && error.response && error.response.data && error.response.data.title) ? error.response.data.title : error.message))
    //     }
    // )
  };
}
